import React from "react";
import { useMutation } from "react-query";
import Axios from "axios";
import {
  antdAsyncMessageError,
  antdAsyncMessageSuccess,
} from "../../../../../helpers/AsyncMessage";
import { Form, Input, Button, Row, Col, Card, Radio } from "antd";
import ModalSpecial from "../../../../../components/Layout/Modals/ModalSpecial";
import RangePickerComp from "../../../../../components/common/RangePickerComp";
import SwitchComp from "../../../../../components/common/SwitchComp";
import UploadFormItem from "../UploadFormItem";
import ColorPickerInput from "../ColorPickerInput";
import dayjs from "dayjs";
import moment from "moment";

const initialState = {
  check: false,
  desktopImageFile: null,
  desktopImageUrl: null,
  mobileImageFile: null,
  mobielImageUrl: null,
  destination_url: null,
  content: null,
  id: null,
};

const ModalNewRuningLineBanner = ({
  onClose,
  modalOpt,
  orderShops,
  bannerData,
}) => {
  const [form] = Form.useForm();
  const [switches, setSwitches] = React.useState({});
  const [selectedValue, setSelectedValue] = React.useState("text");
  const [selectedColor, setSelectedColor] = React.useState("#000000");
  const [color, setColor] = React.useState("#FF00FF");
  const setColorFromChild = React.useRef(null);
  const handleSetColorFromChild = (setColorFunction) => {
    setColorFromChild.current = setColorFunction;
  };
  const handleSetColorFromParrent = (value) => {
    if (setColorFromChild.current) {
      setColorFromChild.current(value);
    }
  };
  const hasRun = React.useRef(false);

  React.useEffect(() => {
    if (!hasRun.current) {
      const initialSwitches = {};
      orderShops.forEach((shop) => {
        initialSwitches[shop.label.replace(" ", "")] = {
          ...initialState,
          id: shop.value,
        };
      });
      setSwitches(initialSwitches);
      hasRun.current = true;
    }
  }, [orderShops]);

  const mutation = useMutation({
    mutationFn: (value) => {
      const formData = new FormData();
      formData.append("banner[title]", value.title);
      formData.append("banner[custom_event]", value.custom_event);
      formData.append("banner[sort_order]", value.sort_order);
      formData.append("banner[banner_place]", "running_line");
      formData.append("banner[background_type]", selectedValue);
      formData.append("banner[background_color]", selectedColor);
      formData.append("banner[valid_from]", value.validity_period[0]);
      formData.append("banner[valid_to]", value.validity_period[1]);

      Object.entries(switches).forEach(([key, switchData], index) => {
        console.log(switchData, "switchData");
        if (!switchData.originalCheckChange) {
          return;
        }
        const desktopFile = switchData?.desktopImageFile;

        if (desktopFile) {
          formData.append(
            `banner[banner_shops_attributes][${index}][desktop_file][data]`,
            desktopFile
          );
          formData.append(
            `banner[banner_shops_attributes][${index}][desktop_file][title]`,
            desktopFile.name
          );
        }

        formData.append(
          `banner[banner_shops_attributes][${index}][destination_url][]`,
          switchData.destination_url
        );
        formData.append(
          `banner[banner_shops_attributes][${index}][content]`,
          switchData.content
        );
        formData.append(
          `banner[banner_shops_attributes][${index}][active]`,
          switchData.check ? "true" : "false"
        );
        formData.append(
          `banner[banner_shops_attributes][${index}][order_shop_id]`,
          switchData.id
        );
        if (modalOpt.type === "edit_running_line") {
          if (switchData.banner_shop_id) {
            formData.append(
              `banner[banner_shops_attributes][${index}][id]`,
              switchData.banner_shop_id
            );
          }
        }
      });

      return Axios[modalOpt.type === "edit_running_line" ? "put" : "post"](
        `/api/v1/banners/${modalOpt.type === "edit_running_line" ? modalOpt.record_id : ""
        }`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      ).then((res) => res.data);
    },
    onSuccess: () => {
      onClose();
      antdAsyncMessageSuccess({ text: "Successfully created", key: "default" });
    },
    onError: antdAsyncMessageError,
  });

  const handleColorChange = (newColor) => {
    setSelectedColor(newColor);
    setColor(newColor);
  };

  const handleFileChange = (name, type, file, url) => {
    console.log({
      name,
      type,
      file,
      url,
    });
    setSwitches((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        [`${type}ImageFile`]: file,
        [`${type}ImageUrl`]: url,
        [`${type}Image`]: file,
        [`${type}ImageFileTitle`]: file?.name,
      },
    }));
  };

  const handleSwitchChange = (name) => {
    setSwitches((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        check: !prev[name].check,
        originalCheckChange: true,
      },
    }));
  };

  const handleInputChange = (name, type, value) => {
    setSwitches((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        [`${type}`]: value,
      },
    }));
  };

  React.useEffect(() => {
    if (modalOpt.type === "edit_running_line") {
      const matchingBanner = bannerData.find(
        (banner) => banner.id === modalOpt.record_id
      );
      console.log(matchingBanner, "matchingBanner");
      if (matchingBanner) {
        form.setFieldsValue({
          title: matchingBanner.title,
          custom_event: matchingBanner.custom_event,
          sort_order: matchingBanner.sort_order,
          validity_period: [
            moment(matchingBanner.valid_from),
            moment(matchingBanner.valid_to),
          ],
        });
        setSelectedValue(matchingBanner.background_type);
        handleSetColorFromParrent(matchingBanner.background_color);
        setColor(matchingBanner.background_color);
        matchingBanner.banner_shops.forEach((shop) => {
          const switchName = shop.order_shop.title?.replace(" ", "");
          setSwitches((prev) => {
            if (prev[switchName]) {
              return {
                ...prev,
                [switchName]: {
                  ...prev[switchName],
                  desktopImageUrl: shop.desktop_image,
                  mobielImageUrl: shop.mobile_image,
                  destination_url: shop.destination_url,
                  check: shop.active,
                  originalCheckChange: true,
                  banner_shop_id: shop.id,
                  content: shop.content || "",
                },
              };
            } else {
              return {
                ...prev,
                [switchName]: {
                  desktopImageUrl: shop.desktop_image,
                  mobielImageUrl: shop.mobile_image,
                  destination_url: shop.destination_url,
                  check: shop.active,
                  originalCheckChange: true,
                  banner_shop_id: shop.id,
                  content: shop.content || "",
                },
              };
            }
          });
          form.setFieldsValue({
            [`destination_url_${switchName}`]: shop.destination_url,
            [`content_${switchName}`]: shop.content || "",
          });
        });
      }
    }
  }, [modalOpt]);

  return (
    <ModalSpecial
      style={{ width: 570 }}
      text={
        <span className="font-bold text-xl text-black">
          {modalOpt.type === "edit_running_line" ? "Edit" : "Add"} running line
          banner
        </span>
      }
      onClose={onClose}
    >
      <Form
        form={form}
        layout="vertical"
        name="basic"
        onFinish={(values) => {
          mutation.mutate(values);
        }}
        autoComplete="off"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: "Can't be empty" }]}
            >
              <Input placeholder="Type in" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Type" name="banner_types">
              <Row gutter={16}>
                <Col span={12}>
                  <div
                    className="card-type ant-input cursor-pointer"
                    style={{
                      marginBottom: 16,
                      height: 32,
                      borderColor: selectedValue === "text" ? "#03B0F7" : "",
                      backgroundColor:
                        selectedValue === "text" ? "#EDF9FE" : "",
                    }}
                    onClick={() => setSelectedValue("text")}
                  >
                    <Radio
                      className={
                        selectedValue === "text" ? "selected-radio" : ""
                      }
                      style={{
                        color: selectedValue === "text" ? "#03B0F7" : "",
                      }}
                      checked={selectedValue === "text"}
                      value="text"
                    >
                      Text
                    </Radio>
                  </div>
                </Col>
                <Col span={12}>
                  <div
                    className="card-type ant-input cursor-pointer"
                    style={{
                      marginBottom: 16,
                      height: 32,
                      borderColor: selectedValue === "image" ? "#03B0F7" : "",
                      backgroundColor:
                        selectedValue === "image" ? "#EDF9FE" : "",
                    }}
                    onClick={() => setSelectedValue("image")}
                  >
                    <Radio
                      className={
                        selectedValue === "image" ? "selected-radio" : ""
                      }
                      style={{
                        color: selectedValue === "image" ? "#03B0F7" : "",
                      }}
                      checked={selectedValue === "image"}
                      value="image"
                    >
                      Image
                    </Radio>
                  </div>
                </Col>
              </Row>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Custom event"
              name="custom_event"
              rules={[{ required: true, message: "Can't be empty" }]}
            >
              <Input placeholder="Type in" />
            </Form.Item>
          </Col>
          <Col span={12}>
            {selectedValue === "text" && (
              <Form.Item label="Background color" name="background_color">
                <ColorPickerInput
                  value={color}
                  onChange={handleColorChange}
                  setColorFromParent={handleSetColorFromChild}
                />
              </Form.Item>
            )}
          </Col>
        </Row>
        <Form.Item
          label="Validity period"
          name="validity_period"
          rules={[{ required: true, message: "Can't be empty" }]}
        >
          <RangePickerComp
            style={{ width: "100%" }}
            showTime={{ format: "HH:mm" }}
            placeholder={["Start time", "End time"]}
            disabledDate={() => false}
          />
        </Form.Item>
        <hr className="hr-margin" />
        {Object.keys(switches).map((switchName) => (
          <div key={switchName}>
            <SwitchComp
              className="d-flex flex-row-reverse justify-content-end"
              labelClassName="ml-1"
              label={switchName.slice(0, 2) + " " + switchName.slice(2)}
              checked={switches[switchName].check}
              onChange={() => handleSwitchChange(switchName)}
            />
            {switches[switchName].check && (
              <div>
                {selectedValue === "image" && (
                  <UploadFormItem
                    name={switchName}
                    label="Image"
                    requiredMessage="Please upload an image!"
                    greyText="Recommended .jpeg, .png format and 1200x644"
                    onFileChange={(file, url) =>
                      handleFileChange(switchName, "desktop", file, url)
                    }
                    externalURL={switches[switchName].desktopImageUrl}
                  />
                )}
                {selectedValue === "text" && (
                  <Form.Item
                    label="Content"
                    name={`content_${switchName}`}
                    rules={[{ required: true, message: "Can't be empty" }]}
                  >
                    <Input
                      placeholder="Type in"
                      onChange={(e) =>
                        handleInputChange(switchName, "content", e.target.value)
                      }
                    />
                  </Form.Item>
                )}
                <Form.Item
                  label="Destination URL"
                  name={`destination_url_${switchName}`}
                  rules={[
                    { required: true, message: "Can't be empty" },
                    () => ({
                      validator(_, value) {
                        const urlPattern = new RegExp(
                          "^(https?:\\/\\/)?" + // protocol
                          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
                          "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
                          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
                          "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
                          "(\\#[-a-z\\d_]*)?$",
                          "i"
                        ); // fragment locator
                        if (!value || urlPattern.test(value)) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Please enter a valid URL")
                        );
                      },
                    }),
                  ]}
                >
                  <Input
                    placeholder="Type in"
                    onChange={(e) =>
                      handleInputChange(
                        switchName,
                        "destination_url",
                        e.target.value
                      )
                    }
                  />
                </Form.Item>
              </div>
            )}
            <hr className="hr-margin" />
          </div>
        ))}
        <Form.Item>
          <Button
            className="w-100"
            type="primary"
            htmlType="submit"
            loading={mutation.isLoading}
          >
            {modalOpt.type === "edit_running_line" ? "Update" : "Add"}
          </Button>
        </Form.Item>
      </Form>
    </ModalSpecial>
  );
};

export default ModalNewRuningLineBanner;
